module.exports = __webpack_public_path__ + "img/790.288ab890.jpg";